import React from 'react'

const Bottom = () => {
  return (
    <div style={{background: '#a01323', height:'5vh', width:'100vw', color: 'transparent'}}>
      100
    </div>
  )
}

export default Bottom
